<template>
  <div class="dropdown driveview" v-show="isShowList">
    <div class="dropdown-toggle" @click="toggleListAndGrid">
      <i class="iconfont" :class="{ 'icon-list': isList, 'icon-grid': !isList}"></i>
      {{ isList ? '列表':'网格' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowList: Boolean,
    isList: Boolean
  },
  name: "List",
  data() {
    return {};
  },
  methods: {
    toggleListAndGrid() {
      let isList = this.isList ? false : true;
      this.$emit("showList", isList);
    }
  }
};
</script>

<style scoped>
.driveview {
  float: right;
  color: #383838;
  cursor: pointer;
}
</style>